export class NICEState {

    stateId: number;
    stateCode: string;
    stateName: string;

    constructor(state?) {
        this.stateId = state.stateId || '';
        this.stateCode = state.stateCode || '';
        this.stateName = state.stateName || '';
    }
}
